const appAlertsState = {
    active: []
};
export default appAlertsState;
